import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import NotificationBell from './NotificationBell';
import { db, doc, updateDoc, serverTimestamp } from '../firebase';

function Header({ user, authUid, onLogout, onLogin }) {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'en', labelKey: 'lang.en' },
    { code: 'de', labelKey: 'lang.de' },
    { code: 'ar', labelKey: 'lang.ar' },
    { code: 'ku', labelKey: 'lang.ku' },
  ];

  const resolved = i18n.resolvedLanguage?.split('-')[0] || 'en';
  const homeTo = authUid ? '/dashboard/profile' : '/';

  return (
    <header className="haydi-header">
      <div className="haydi-header__row">
        <Link to={homeTo} className="haydi-header__brand">
          {t('appName')}
        </Link>
        <div className="haydi-header__actions">
          <select
            aria-label={t('language')}
            className="haydi-header__lang"
            value={resolved}
            onChange={async (e) => {
              const v = e.target.value;
              await i18n.changeLanguage(v);
              if (user?.uid) {
                try {
                  await updateDoc(doc(db, 'users', user.uid), {
                    preferredLanguage: v,
                    updatedAt: serverTimestamp(),
                  });
                } catch (err) {
                  console.error(err);
                }
              }
            }}
          >
            {languages.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {t(lang.labelKey)}
              </option>
            ))}
          </select>
          {authUid ? (
            <>
              {user && <NotificationBell user={user} />}
              <span className="haydi-header__email" title={user?.email}>
                {user?.email}
              </span>
              <button type="button" className="haydi-header__btn" onClick={onLogout}>
                {t('logout')}
              </button>
            </>
          ) : (
            <button type="button" className="haydi-header__btn" onClick={onLogin}>
              {t('login')}
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
